import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import swal from 'sweetalert2';

@Injectable()
export class VersionCheckService {
    // this will be replaced by actual hash post-build.js
    private currentHash = '{{POST_BUILD_ENTERS_HASH_HERE}}';
    private frequency = 10000 * 60;
    private run;
    constructor(private httpClient: HttpClient) {}

    /**
     * Checks in every set frequency the version of frontend application
     * @param webapp_version
     * @param {number} frequency - in milliseconds, defaults to 30 minutes
     */
    public initVersionCheck(webapp_version) {
        this.run = setInterval(() => {
            this.checkVersion(webapp_version);
        }, this.frequency);
    }

    /**
     * Will do the call and check if the hash has changed or not
     * @param url
     */
    private checkVersion(webapp_version) {
        // timestamp these requests to invalidate caches
        this.httpClient.get(`VersionManagements/get-latest-version`)
            .subscribe(
                (response: any) => {
                    const curr_version = response.version;
                    if(curr_version != webapp_version) {
                        swal({
                            title: "New Version Available!",
                            text: `New version ${webapp_version} is available now.`,
                            type: "info",
                            showCancelButton: true,
                            confirmButtonColor: "#3085d6",
                            cancelButtonColor: "#3085d6",
                            confirmButtonText: "Refresh",
                            cancelButtonText: "Maybe Later",
                            confirmButtonClass: "btn adjust-swal-button",
                            cancelButtonClass: "btn adjust-swal-button",
                            buttonsStyling: false
                          }).then(result => {
                            if (result.value) {
                                window.location.reload();
                            } else {
                                clearInterval(this.run);
                                this.frequency = this.frequency * 2;
                                this.run = setInterval(() => {
                                    this.checkVersion(curr_version);
                                }, this.frequency);
                            }
                          });
                        
                    }
                },
                (err) => {
                    console.error(err, 'Could not get version');
                }
            );
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/services/version-check.service.ts